export default __webpack_public_path__ + "b42a5c71521e214f9f073b18b23bcf4e.jpg";